import {mapValues} from 'lodash'
import type {Actions} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {ManifestFeatureGfppDesktopConfig} from '@wix/document-services-types'
import {BaseActionsBuilder} from './BaseActionsBuilder'
import type {ManifestActionValue} from './types'
import {ActionsHelpers} from './ActionsHelpers'

export class NativeActionsBuilder extends BaseActionsBuilder<Actions> {
    protected pickSupportedActions = (data: ManifestFeatureGfppDesktopConfig) => {
        return ActionsHelpers.pickNativeActionValues(data)
    }

    protected transformToBuilderActions(data: Record<string, ManifestActionValue>) {
        const mapped = ActionsHelpers.getMappedNativeActionKeys(data)
        return mapValues(mapped, action => this.actionExecutionBuilder.build(action))
    }
}
